<template>
  <sweet-modal ref="modal" overlay-theme="dark">
    <div class="pb-2 text-left">
      <h4>{{ $t('message.promotion.select_service') }}</h4>
    </div>
    
    <div class="service-grid-container">
      <div class="service-grid-item" v-for="service in services">
        <router-link :to="`/booking/start?sid=${service.id}`" class="no-style">
          <div class="card">
            <div class="card-image">
              <img :src="service.picture" alt="">
            </div>
          </div>
          <div class="text-dark px-2">{{ service | multiLangName  }}</div>
        </router-link>
      </div>
    </div>
  </sweet-modal>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { SweetModal } from 'sweet-modal-vue'
  export default {
    props: {
      promotion: Object
    },
    components: {
      SweetModal
    },
    data () {
      return {
        services: []
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState'
      })
    },
    methods: {
      openModal () {
        this.$refs.modal.open()
      },
      closeModal () {
        this.$refs.modal.close()
      }
    },
    mounted () {
      if (this.promotion && this.promotion.promo_code && this.promotion.promo_code.service_id) {
        Object.keys(this.globalState.services).forEach(id => {
          const service = this.globalState.services[id]
          if (service.id === this.promotion.promo_code.service_id) {
            this.services.push(service)
          }
        })
      } else {
        Object.keys(this.globalState.services).forEach(id => {
          const service = this.globalState.services[id]
          if (service.service_type === 'popular') {
            this.services.push(service)
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/promotion/SelectServiceModal.vue